export const newsMock = {
  ResponseCode: 200,
  ResponseDetail: 'Ok',
  Result: {
    __type: 'ResponseQueryList:#Consorcio.Transar.Entities.Common.Request',
    Resultado: [
      {
        ID: 4,
        Valores: [
          {
            NombreInternoCampo: 'PublishingPageImage',
            Valor:
              '<img alt="" src="https://corporativo.compensar.com/salud/Not/PublishingImages/Paginas/Forms/AllItems/Foto_nota_ecoopsos.png" style="BORDER: 0px solid; ">',
          },
          {
            NombreInternoCampo: 'Title',
            Valor: 'Las medidas que multiplicaron los hipertensos del mundo',
          },
          {
            NombreInternoCampo: 'Comments',
            Valor:
              'Nos complace compartir con nuestros afiliados las nominaciones que tuvimos como EPS del régimen contributivo: mejores resultados en gestión de enfermedades de alto.',
          },
          {
            NombreInternoCampo: 'DescripcionNoticia',
            Valor:
              // eslint-disable-next-line no-useless-escape
              '<style>.algo-para-decorar{ text-decoration: underline; }</style><div class=\"ExternalClass747B9E845AFF4B8C9F92A7EBF4A892DC\"><p>Mas <span class="algo-para-decorar">de</span> lo ultimo&#160;rumba en rumba,&#160;&lt;div style=&quot;border&#58; 1px solid #000;&quot;&gt;solo notiicas amarillistas&lt;/div&gt;​​<br></p></div>.',
          },
          {
            NombreInternoCampo: 'ColorTitulo',
            Valor: '#000000',
          },
          {
            NombreInternoCampo: 'NuevaVentana',
            Valor: 'False',
          },
          {
            NombreInternoCampo: 'Detalle',
            Valor: 'COMPENSAR',
          },
          {
            NombreInternoCampo: 'FechaFin',
            Valor: '12/30/2023 00:00:00',
          },
          {
            NombreInternoCampo: 'FechaInicio',
            Valor: '5/26/2020 00:00:00',
          },
          {
            NombreInternoCampo: 'ColorDetalle',
            Valor: '#f60',
          },
          {
            NombreInternoCampo: 'Mostrar',
            Valor: 'True',
          },
          {
            NombreInternoCampo: 'Ordenar',
            Valor: '2',
          },
          {
            NombreInternoCampo: 'FileRef',
            Valor: '/salud/NotInicio/Paginas/MedMul.aspx',
          },
        ],
      },
      {
        ID: 3,
        Valores: [
          {
            NombreInternoCampo: 'PublishingPageImage',
            Valor:
              '<img alt="" src="https://corporativo.compensar.com/salud/Not/PublishingImages/Paginas/Forms/AllItems/Imagen_nota_rendicion_cuentas.png" style="BORDER: 0px solid; ">',
          },
          {
            NombreInternoCampo: 'Title',
            Valor: 'Con la calidad de salud no se puede tomar ningún riesgo',
          },
          {
            NombreInternoCampo: 'Comments',
            Valor:
              'No te quedes atrás y actualiza tus datos personales y así estar al día con toda tu información en nuestros sistemas. Sigue este paso a paso y descubrirás lo fácil que es.',
          },
          {
            NombreInternoCampo: 'DescripcionNoticia',
            Valor:
              'Segunda <button class="btn btn-primary">Afiliate</button> que es primaria <div style="border: 1px solid #f60">Ejemplito</div>, última noticia.',
          },
          {
            NombreInternoCampo: 'ColorTitulo',
            Valor: '#000000',
          },
          {
            NombreInternoCampo: 'NuevaVentana',
            Valor: 'False',
          },
          {
            NombreInternoCampo: 'Detalle',
            Valor: 'SALUD',
          },
          {
            NombreInternoCampo: 'FechaFin',
            Valor: '12/24/2023 00:00:00',
          },
          {
            NombreInternoCampo: 'FechaInicio',
            Valor: '7/24/2022 00:00:00',
          },
          {
            NombreInternoCampo: 'ColorDetalle',
            Valor: '#f60',
          },
          {
            NombreInternoCampo: 'Mostrar',
            Valor: 'True',
          },
          {
            NombreInternoCampo: 'Ordenar',
            Valor: '3',
          },
          {
            NombreInternoCampo: 'FileRef',
            Valor: '/salud/NotInicio/Paginas/CalSalud.aspx',
          },
        ],
      },
      {
        ID: 2,
        Valores: [
          {
            NombreInternoCampo: 'PublishingPageImage',
            Valor: '',
          },
          {
            NombreInternoCampo: 'Title',
            Valor: 'Actualízate sin demoras y desde casa',
          },
          {
            NombreInternoCampo: 'Comments',
            Valor:
              'No te quedes atrás y actualiza tus datos personales y así estar al día con toda tu información en nuestros sistemas. Sigue este paso a paso y descubrirás lo fácil que es.',
          },
          {
            NombreInternoCampo: 'DescripcionNoticia',
            Valor: '<div style="border: 1px solid #000">Chao</div>, última noticia.',
          },
          {
            NombreInternoCampo: 'ColorTitulo',
            Valor: '#000000',
          },
          {
            NombreInternoCampo: 'NuevaVentana',
            Valor: 'False',
          },
          {
            NombreInternoCampo: 'Detalle',
            Valor: 'SALUD',
          },
          {
            NombreInternoCampo: 'FechaFin',
            Valor: '12/24/2023 00:00:00',
          },
          {
            NombreInternoCampo: 'FechaInicio',
            Valor: '7/24/2022 00:00:00',
          },
          {
            NombreInternoCampo: 'ColorDetalle',
            Valor: '#f60',
          },
          {
            NombreInternoCampo: 'Mostrar',
            Valor: 'True',
          },
          {
            NombreInternoCampo: 'Ordenar',
            Valor: '4',
          },
          {
            NombreInternoCampo: 'FileRef',
            Valor: '/salud/NotInicio/Paginas/ActDem.aspx',
          },
        ],
      },
      {
        ID: 1,
        Valores: [
          {
            NombreInternoCampo: 'PublishingPageImage',
            Valor: '',
          },
          {
            NombreInternoCampo: 'Title',
            Valor: 'Última noticia del mes',
          },
          {
            NombreInternoCampo: 'Comments',
            Valor:
              'Es muy raro esto de los comentarios y así estar al día con toda tu información en nuestros sistemas. Sigue este paso a paso y descubrirás lo fácil que es.',
          },
          {
            NombreInternoCampo: 'DescripcionNoticia',
            Valor: '<div style="border: 1px solid #000">Hola</div>, última noticia.',
          },
          {
            NombreInternoCampo: 'ColorTitulo',
            Valor: '#000000',
          },
          {
            NombreInternoCampo: 'NuevaVentana',
            Valor: 'False',
          },
          {
            NombreInternoCampo: 'Detalle',
            Valor: 'SALUD',
          },
          {
            NombreInternoCampo: 'FechaFin',
            Valor: '12/24/2023 00:00:00',
          },
          {
            NombreInternoCampo: 'FechaInicio',
            Valor: '7/24/2022 00:00:00',
          },
          {
            NombreInternoCampo: 'ColorDetalle',
            Valor: '#f60',
          },
          {
            NombreInternoCampo: 'Mostrar',
            Valor: 'True',
          },
          {
            NombreInternoCampo: 'Ordenar',
            Valor: '4',
          },
          {
            NombreInternoCampo: 'FileRef',
            Valor: '/salud/NotInicio/Paginas/ActDem.aspx',
          },
        ],
      },
    ],
  },
};
